import { Avatar as DiceBearAvatar, Style } from '@dicebear/core'
import personasDefinition from '@dicebear/styles/personas.json' with { type: 'json' }
import type { AvatarConfig } from '@super-mega/server/contracts/profile'
import {
  DEFAULT_AVATAR_SIZE,
  USER_AVATAR_BACKGROUND_OPTIONS,
  USER_AVATAR_SEEDS
} from '@/features/profile/const/avatar-options.ts'

export type { AvatarBackground, AvatarConfig, AvatarPattern } from '@super-mega/server/contracts/profile'

const personasStyle = new Style(personasDefinition)

export function getUserAvatarDataUri({ avatar, size = DEFAULT_AVATAR_SIZE }: { avatar: AvatarConfig; size?: number }) {
  return new DiceBearAvatar(personasStyle, {
    backgroundColor: USER_AVATAR_BACKGROUND_OPTIONS[avatar.background].color,
    borderRadius: 50,
    seed: USER_AVATAR_SEEDS[avatar.pattern],
    size
  }).toDataUri()
}

export {
  DEFAULT_AVATAR_SIZE,
  DEFAULT_USER_AVATAR,
  USER_AVATAR_BACKGROUND_OPTIONS,
  USER_AVATAR_BACKGROUNDS,
  USER_AVATAR_PATTERNS,
  USER_AVATAR_SEEDS
} from '@/features/profile/const/avatar-options.ts'
